export default __webpack_public_path__ + "static/media/B01.e581e08d.png";